// src/pages/mission/components/AlertBanner.jsx

import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { getColorClasses } from '../../themeConfig';

const AlertBanner = ({ alertColor }) => {
  return (
    <div className={`${getColorClasses(alertColor, 'alertBg')} border-b-2 ${getColorClasses(alertColor, 'alertBorder')} py-3 px-4 flex items-center justify-center gap-2 mb-8 rounded-lg`}>
      <AlertTriangle className={`${getColorClasses(alertColor)} animate-pulse`} size={20} />
      <span className={`${getColorClasses(alertColor, 'alertText')} text-sm font-mono tracking-wider`}>
        PREPARE FOR DEPLOYMENT - EQUIPMENT CHECK REQUIRED
      </span>
      <AlertTriangle className={`${getColorClasses(alertColor)} animate-pulse`} size={20} />
    </div>
  );
};

export default AlertBanner;